import { useQueryClient } from '@workspace/api';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useInit } from '../api/ws';
import { useGlobalForm } from '../contexts/global-form-context';
import { LoaderScreen } from '../components';

export default function Key() {
    const { key } = useParams();
    const { actions, origin } = useGlobalForm();
    const query = useInit({
        key,
        origin: origin || 'site',
    });

    const queryClient = useQueryClient();
    const hasInitializedRef = useRef(false);

    useEffect(() => {
        if (query.isSuccess && !hasInitializedRef.current) {
            hasInitializedRef.current = true;
            queryClient.setQueryData(['init', { key: undefined, origin: origin || 'site', token: query.data.token }], query.data);
            actions.saveInitialData(query.data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query.isSuccess]);

    return <LoaderScreen />;
}
